import { LitElement, html, css } from 'lit';
import { customElement, property } from 'lit/decorators.js';

@customElement('bia-suggestion-chips')
export class BiaSuggestionChips extends LitElement {
  static styles = css`
    :host { display: block; padding: 8px 0; }
    .row { display: flex; flex-wrap: wrap; gap: 6px; }
    button {
      background: transparent;
      border: 1px solid var(--bia-border, #E0E0E0);
      border-radius: 16px;
      padding: 4px 12px;
      cursor: pointer;
      font-family: var(--bia-font-family, sans-serif);
      color: var(--bia-text, #212121);
    }
    button:hover { background: var(--bia-surface, #F5F5F5); }
  `;

  @property({ type: Array }) suggestions: string[] = [];

  private pick(suggestion: string): void {
    this.dispatchEvent(
      new CustomEvent<string>('pick', {
        detail: suggestion,
        bubbles: true,
        composed: true,
      }),
    );
  }

  render() {
    if (!this.suggestions.length) return html``;
    return html`
      <div class="row">
        ${this.suggestions.map(
          (s) => html`<button @click=${() => this.pick(s)}>${s}</button>`,
        )}
      </div>
    `;
  }
}
